import LocationStorageProvider from './LocationStorageProvider';
import LocationSyncClient from './LocationSyncClient';

export default class LocationTracker {

  /**
   * Create a location tracker for a book.
   * @param {number} bookId 
   * @param {LocationStorageProvider} storageProvider 
   * @param {LocationSyncClient} locationSyncClient 
   */
  constructor(bookId, storageProvider, locationSyncClient) {

    /** @type {number} */
    this.bookId = bookId;

    this.storageProvider = storageProvider || null;
    this.locationSyncClient = locationSyncClient || null;
  }

  updateLocation(cfi) {

    this.storageProvider && this.storageProvider.storeLocation(this.bookId, cfi);
    this.locationSyncClient && this.locationSyncClient.sendLocationUpdate(this.bookId, cfi);

  }

  async loadLocation() {

    const syncResult = this.locationSyncClient && await this.locationSyncClient.retrieveLastLocationUpdate(this.bookId);
    const storageResult = this.storageProvider && this.storageProvider.loadLocation(this.bookId);

    if (storageResult && syncResult) {
      // compare the timestamps on the two results
      if (
        // Decided to rename dateCreated on local storage to dateModified to
        // align with server response, the logical OR ensures both will work
        Date.parse(storageResult.dateModified || storageResult.dateCreated)
        > Date.parse(syncResult.dateModified)
      ) {
        return storageResult.location;
      } else {
        return syncResult.location;
      }
    } else {
      return storageResult?.location || syncResult?.location;
    }    
  }
}